import { NgFor, NgIf } from "@angular/common";
import { HorizontalTextInputComponent } from "../../../../../../assist/src/app/_shared/form/components/horizontal-text-input/horizontal-text-input.component";
import { ButtonComponent } from "../../../../../../assist/src/app/_shared/form/components/button/button.component";
import { Component, OnInit } from "@angular/core";
import { Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BasePage } from "../../../../../../assist/src/app/_shared/components/layout/pages/base-page";
import { GlobalVariables } from "../../../../../../assist/src/app/_shared/services/global.service";
import { SubscriptionDto } from "../../../../../../assist/src/app/organisation/models/subscription";
import { SubscriptionRenewModalComponent } from "../../../../../../assist/src/app/subscription/pages/subscription-renew-modal/subscription-renew-modal.component";
import { UserOrganizationList } from "../../../../../../assist/src/app/users/models/userOrganization";
import { AssistAuthService } from "../../../auth/assist-auth.service";
import { OrganizationService } from "../../../organization/services/oranization.service";
import { UserPersonService } from "../../services/user-person.service";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserPersonListDto } from "../../models/user-person";
import { OrganizationPublicAccessKeyDto } from "../../../../../../assist/src/app/organisation/models/organization";



@Component({
  selector: 'app-person-modal',
  templateUrl: './person-modal.component.html',
  styleUrls: ['./person-modal.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    HorizontalTextInputComponent,
    ButtonComponent,
    NgFor,
  ],
})
export class PersonModalComponent extends BasePage implements OnInit {

  organization: OrganizationPublicAccessKeyDto = {} as OrganizationPublicAccessKeyDto;
  persons: UserPersonListDto[] = [];

  constructor(
    protected override route: ActivatedRoute,
    protected override modal: NgbModal,
    protected router: Router,
    public auth: AssistAuthService,
    protected userPersonService: UserPersonService,
    protected organizationService: OrganizationService,
    protected activeModal: NgbActiveModal,
  ) {
    super(route, modal);
  }

  ngOnInit(): void {
    this.isLoading = true;
    this.organizationService.getAccessKey().subscribe((o) => {
      this.organization = o;
      this.userPersonService.getAll('?organizationKey=' + this.organization.accessKey).subscribe(x => {
        this.persons = x;
        this.isLoading = false;

        if (this.persons.length == 1) {
          const person = this.persons[0];
          this.router.navigate(['/NL/', this.organization.accessKey, 'person', person.person.accessKey, 'edit']).then(() => {
            this.close()
          });
        }
      })
    })
  }

  close() {
    this.activeModal.close();
  }

  loginAs(p: UserPersonListDto) {
    this.router.navigate(['/NL/', this.organization.accessKey, 'person', p.person.accessKey, 'edit']).then(() => {
      this.close()
    });
  }

}
